import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Product } from 'src/app/modules/shared/models/products.model';

@Component({
  selector: 'product-expansion',
  templateUrl: './product-expansion.component.html',
  styleUrls: ['./product-expansion.component.scss'],
})
export class ProductExpansionComponent implements OnChanges {
  @Input() product: Product;
  productDescriptions: any[] = [];
  productData: any[] = [];
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    this.setProductDescriptions();
  }

  private removeSpaces(str: string) {
    return str.replace(/\s/g, '');
  }

  private setProductDescriptions() {
    // this.productData = [
    //   {
    //     title: 'description',
    //     value: this.product.store_product_detail.marketing_description,
    //   },
    //   {
    //     title: 'redemption',
    //     value: this.product.store_product_detail.redeem_description,
    //   },
    //   {
    //     title: 'terms and conditions',
    //     value: this.product.store_product_detail.terms,
    //   },
    // ];
    try {
      let descriptionList = JSON.parse(
        this.product?.store_product_detail?.description ||
          this.product?.description
      );
      for (let item of descriptionList.content) {
        if (item.description && this.removeSpaces(item.description) !== '') {
          this.productDescriptions.push(item);
        }
      }
    } catch (error) {
      if (
        this.product?.store_product_detail?.description ||
        this.product?.description
      ) {
        let description = {
          title: 'Description',
          type: 'description',
          description:
            this.product.store_product_detail?.description ||
            this.product?.description,
        };
        this.productDescriptions.push(description);
      }
    }
  }
}
